export function isMobileDevice() {
  this.windowDimensions = {
    height: window.innerHeight,
    width: window.innerWidth,
  };
  if (this.windowDimensions.width <= 915) return true;
  else return isMobileOs();
}

function isMobileOs() {
  //Storing user's device details in a variable
  let details = navigator.userAgent;

  //Creating a regular expression containing some mobile devices keywords to search it in details string
  let regexp = /android|iphone|kindle|ipad/i;

  //Using test() method to search regexp in details it returns boolean value
  return regexp.test(details);

  //check window orientation, if -1 desktop
  //depreciated method
  //return window.orientation > -1;
}

export function validateEmailPhone(value, regExpr) {
  value = value.trim();

  return validatePhoneNumber(value, regExpr) || validateEmail(value);
}

export function validateEmail(email) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) return true;
  else return false;
}

export function validatePhoneNumber(phoneNo, expr) {
  if (!phoneNo || !isNumeric(phoneNo)) return false;

  if (!expr) return true;

  const regex = new RegExp(expr);

  return regex.test(phoneNo);
}

export function isNumeric(str) {
  if (typeof str != "string") return false;

  return /^\d+$/.test(str);
}

const menuDef = [
  {
    id: "userHome",
    name: "Home page",
    icon: "home",
    requiresAuth: true,
    empl: false,
    descr: "",
  },
  {
    id: "account",
    name: "Account Details",
    icon: "person",
    requiresAuth: true,
    empl: false,
    descr: "AccountDetailsDescr",
  },
  {
    id: "financial",
    name: "Financial Transaction Details",
    icon: "attach_money",
    requiresAuth: true,
    empl: false,
    descr: "FinancialTransactionDetailsDescr",
  },
  {
    id: "readings",
    name: "Meter Readings",
    icon: "timeline",
    requiresAuth: true,
    empl: false,
    descr: "MeterReadingsDescr",
  },
  {
    id: "apps",
    name: "Applications",
    icon: "description",
    requiresAuth: true,
    empl: false,
    descr: "ApplicationsDescr",
  },
  {
    id: "emails",
    name: "Emails",
    icon: "alternate_email",
    requiresAuth: true,
    empl: false,
    descr: "EmailsDescr",
  },
  {
    id: "attachments",
    name: "Attachments",
    icon: "attach_file",
    requiresAuth: true,
    empl: false,
    descr: "AttachmentsDescr",
  },
  {
    id: "dashscreen",
    name: "Dashscreen",
    icon: "analytics",
    requiresAuth: true,
    empl: false,
    descr: "DashboardsDescr",
  },
  {
    id: "billPayment",
    name: "Bill Payment",
    icon: "payment",
    requiresAuth: true,
    empl: false,
    descr: "BillPaymentDescr",
  },
  {
    id: "contactUs",
    name: "Contact Us",
    icon: "call",
    requiresAuth: true,
    empl: false,
    descr: "ContactUsDescr",
  },

  // employee
  {
    id: "employeeHome",
    name: "Home page",
    icon: "home",
    requiresAuth: true,
    empl: true,
    descr: "",
  },
  {
    id: "applications",
    name: "Applications",
    icon: "contact_mail",
    requiresAuth: true,
    empl: true,
    descr: "EmployeeApplicationsDescr",
  },
  {
    id: "omApplications",
    name: "OmApplications",
    icon: "perm_data_setting",
    requiresAuth: true,
    empl: true,
    descr: "OmApplicationsDescr",
  },
  {
    id: "disconnections",
    name: "Disconnections",
    icon: "format_color_reset",
    requiresAuth: true,
    empl: true,
    descr: "DisconnectionsDescr",
  },
  {
    id: "dm",
    name: "Dm",
    icon: "format_color_reset",
    requiresAuth: true,
    empl: true,
    descr: "DmDescr",
  },
  {
    id: "assets",
    name: "Assets",
    icon: "business",
    requiresAuth: true,
    empl: true,
    descr: "AssetsDescr",
  },
  {
    id: "elements",
    name: "Elements",
    icon: "extension",
    requiresAuth: true,
    empl: true,
    descr: "ElementsDescr",
  },
  {
    id: "logs",
    name: "Logs",
    icon: "assignment",
    requiresAuth: true,
    empl: true,
    descr: "LogsDescr",
  },
  {
    id: "samples",
    name: "Samples",
    icon: "format_color_fill",
    requiresAuth: true,
    empl: true,
    descr: "SamplesDescr",
  },
  {
    id: "captureMeterReadings",
    name: "CaptureMeterReadings",
    icon: "assignment_turned_in",
    requiresAuth: true,
    empl: true,
    descr: "CaptureMeterReadingsDescr",
  },
  //{ id: 'gis', params: { command: 'zoomToMap', param: 0 }, name: 'GIS', icon: 'map', requiresAuth: true, empl: true, descr: 'GISDescr' },
  {
    id: "webgis",
    name: "GIS",
    icon: "map",
    requiresAuth: true,
    empl: true,
    descr: "GISDescr",
  },
  {
    id: "gisAdministration",
    name: "GIS Administration",
    icon: "settings",
    requiresAuth: true,
    empl: true,
    descr: "GISAdministrationDescr",
  },
];

export function getMenuItems(user, roles) {
  var menu = menuDef;
  if (user && user.authenticated) {
    if (user.role == roles.Employee)
      return menu.filter(function (item) {
        return item.empl;
      });
    else
      return menu.filter(function (item) {
        return !item.empl;
      });
  } else
    return menu.filter(function (item) {
      return !item.requiresAuth;
    });
}
